<!--
 * @Author: Lemon C
 * @Date: 2024-05-15 09:37:00
 * @LastEditTime: 2025-03-17 10:04:39
-->
<template>
    <div class="sup-msg-list-comp">
        <div class="top-box">
            <span class="top-tip">{{ '全部消息（' + msg_list.length + '）' }}</span>
            <div class="top-right-box">
                <el-icon><Brush /></el-icon>
                <span class="right-dis" @click="all_del_click">一键删除</span>
            </div>
            <div class="top-right-box">
                <el-icon><Brush /></el-icon>
                <span class="right-dis" @click="all_read_click">一键已读</span>
            </div>
        </div>
        <div class="list-box">
            <div
                :class="`item-box ${msg_sel_item && msg_sel_item.messageId === item.messageId ? 'isActive' : ''}`"
                v-for="(item, index) in msg_list"
                :key="index"
                @click="msg_item_click(item)">
                <div class="item-top">
                    <el-icon><UploadFilled /></el-icon>
                    <span class="item-title">{{ item.title }}</span>
                    <span class="item-time">{{ formatTime_YMD(item.publishTime) }}</span>
                </div>
                <div class="item-bottom">
                    <span class="item-msg">{{ item.message }}</span>
                    <el-icon @click.stop="del_click(item)"><Delete /></el-icon>
                </div>
            </div>
        </div>
        <!-- <div class="page-box">
            <el-pagination
                :small="true"
                @size-change="elpagination_size_change"
                @current-change="elpagination_current_change"
                :current-page="elpagination_curr_page"
                :page-size="10"
                :pager-count="5"
                layout="prev, pager, next, jumper"
                :total="msg_list.length">
            </el-pagination>
        </div> -->
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onMounted, nextTick, getCurrentInstance, watch } from 'vue';
import { getMessageList, receivedMessage, receivedMessageList, delMessages, delAllMessages } from '@/service/interface';
import { formatTime_YMD } from '@/utils/generalMethods';

const { proxy } = getCurrentInstance();

const props = defineProps({
    msg_request_type: Number,
    comp_msg_item_callback: Function,
    comp_msg_update_callback: Function,
});

const msg_list = ref([]);
const elpagination_curr_page = ref(1);
const msg_sel_item = ref(null);

watch(
    () => props.msg_request_type,
    () => {
        service_get_msg();
    }
);

onMounted(() => {
    service_get_msg();
});

// MARK Service  信息列表
const service_get_msg = () => {
    proxy.$showLoading();
    let params = {
        type: props.msg_request_type,
    };
    getMessageList({ params }).then((res) => {
        proxy.$hideLoading();
        if (res.isSuccess) {
            msg_list.value = [];
            msg_list.value = res.data;
        }
    });
};
// MARK el-pagination  PageSize改变
const elpagination_size_change = (val) => {
    // console.log(`每页 ${val} 条`);
};
// MARK el-pagination  CurrentPage改变
const elpagination_current_change = (val) => {
    // console.log(`当前页: ${val}`);
};
// MARK Click  Item点击
const msg_item_click = (item) => {
    nextTick(() => {
        msg_sel_item.value = item;
    });
    props.comp_msg_item_callback && props.comp_msg_item_callback(item);
    receivedMessage(item.messageId).then((res) => {
        if (res.isSuccess) {
            props.comp_msg_update_callback && props.comp_msg_update_callback();
        }
    });
};

// MARK Click  一键已读
const all_read_click = () => {
    proxy.$showLoading();
    let params = {
        messageIds: msg_list.value.map((item) => item.messageId),
    };
    receivedMessageList(params).then((res) => {
        proxy.$hideLoading();
        if (res.isSuccess) {
            service_get_msg();
            props.comp_msg_update_callback && props.comp_msg_update_callback();
        }
    });
};

// MARK Click  一键删除
const all_del_click = () => {
    proxy
        .$confirm('确认删除所有消息？')
        .then(() => {
            proxy.$showLoading();
            delAllMessages().then((res) => {
                proxy.$hideLoading();
                if (res.isSuccess) {
                    service_get_msg();
                    props.comp_msg_update_callback && props.comp_msg_update_callback();
                }
            });
        })
        .catch(() => {});
};

// MARK Click  删除
const del_click = (item) => {
    proxy
        .$confirm('确认删除此消息？')
        .then(() => {
            proxy.$showLoading();
            let params = {
                messageIds: [item.messageId],
            };
            delMessages(params).then((res) => {
                proxy.$hideLoading();
                if (res.isSuccess) {
                    service_get_msg();
                    props.comp_msg_update_callback && props.comp_msg_update_callback();
                }
            });
        })
        .catch(() => {});
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-msg-list-comp {
    position: relative;
    display: flex;
    flex-direction: column;
    border-right: 1px solid var(--color-main-doc-segmentation-line-bg);
    padding: 10px 10px 10px 20px;
    box-sizing: border-box;
    align-items: center;

    .top-box {
        position: relative;
        width: 100%;
        height: 70px;
        display: flex;
        // justify-content: space-between;
        align-items: center;
        flex-shrink: 0;

        .top-tip {
            position: relative;
            flex: 1;
            font-weight: 500;
            font-size: 16px;
            color: var(--color-main-text-primary);
            line-height: 24px;
        }

        .top-right-box {
            position: relative;
            width: 100px;
            flex-shrink: 0;
            margin-right: 10px;
            display: flex;
            align-items: center;
            cursor: pointer;
            padding: 2px 5px;
            border-radius: 5px;
            border: 1px solid var(--color-main-brand-hover-light);

            &:hover {
                border: 1px solid var(--color-main-brand-hover-light);
                background-color: var(--color-main-brand-hover-light);
            }

            i {
                margin-right: 8px;
                color: var(--color-main-brand);
                font-size: 16px;
            }

            .right-dis {
                font-weight: 400;
                font-size: 16px;
                color: var(--color-main-text-primary);
                line-height: 24px;
            }
        }
    }

    .list-box {
        position: relative;
        margin-bottom: 10px;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        overflow-y: auto;
        padding-right: 10px;
        box-sizing: border-box;

        .item-box {
            position: relative;
            width: 100%;
            height: 87px;
            margin-bottom: 5px;
            padding: 5px 10px;
            box-sizing: border-box;

            &.isActive,
            &:hover {
                background: var(--color-main-brand-hover-light);
                border-radius: 4px;
            }

            .item-top {
                position: relative;
                width: 100%;
                height: 40px;
                display: flex;
                align-items: center;

                i {
                    font-size: 20px;
                    color: var(--color-main-msg-green-bg);
                    flex-shrink: 0;
                }

                .item-title {
                    position: relative;
                    margin-left: 10px;
                    margin-right: 10px;
                    flex: 1;
                    font-weight: 400;
                    font-size: 16px;
                    color: var(--color-main-text-primary);
                    line-height: 24px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .item-time {
                    position: relative;
                    font-weight: 400;
                    font-size: 14px;
                    color: var(--color-main-text-secondary-gray);
                    line-height: 20px;
                }
            }

            .item-bottom {
                position: relative;
                display: flex;
                flex: 1;
                margin-top: 5px;
                padding-left: 30px;
                box-sizing: border-box;
                align-items: center;

                .item-msg {
                    position: relative;
                    margin-right: 10px;
                    flex: 1;
                    font-weight: 400;
                    font-size: 16px;
                    color: var(--color-main-text-primary);
                    line-height: 24px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                i {
                    font-size: 15px;
                    color: var(--color-main-text-secondary);
                    flex-shrink: 0;
                }
            }
        }
    }

    .page-box {
        position: relative;
        height: 30px;
        display: flex;
        flex-shrink: 0;
        align-items: center;

        .el-pagination {
            display: flex;
        }
    }
}
</style>
